export default __webpack_public_path__ + "static/stick-sports-14c5dd174badf2789a0b7972ed4af772.svg";